import { CaptionsTranscript, TranscriptChapter } from '@osmosis/shared/video';

/**
 * Number of entries shown in the locked preview for logged-out users.
 */
export const SHORT_TRANSCRIPT_ENTRIES = 5;

/**
 * Produce a shortened copy of a {@link CaptionsTranscript} that keeps at most
 * `maxEntries` entries across all chapters. Chapter grouping is preserved: the
 * boundary chapter is trimmed to fit the budget and chapters that contribute no
 * entries are dropped, so chips/headings only appear for chapters present in the
 * preview.
 */
export function truncateCaptionsTranscript(
  transcript: CaptionsTranscript,
  maxEntries = SHORT_TRANSCRIPT_ENTRIES,
): CaptionsTranscript {
  const chapters: TranscriptChapter[] = [];
  let remaining = maxEntries;

  for (const chapter of transcript.chapters) {
    if (remaining <= 0) break;

    const entries = chapter.entries.slice(0, remaining);
    if (!entries.length) continue;

    chapters.push({ ...chapter, entries });
    remaining -= entries.length;
  }

  return { ...transcript, chapters };
}
